import { render, staticRenderFns } from "./WidgetBuilder.vue?vue&type=template&id=2ed084c8&scoped=true&"
import script from "./WidgetBuilder.vue?vue&type=script&lang=js&"
export * from "./WidgetBuilder.vue?vue&type=script&lang=js&"
import style0 from "./WidgetBuilder.vue?vue&type=style&index=0&id=2ed084c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed084c8",
  null
  
)

export default component.exports